<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #444;
  -webkit-overflow-scrolling:touch;
  overflow:hidden;
  height: 100%;
}
.el-main{
  padding:0px !important;
}

</style>


// WEBPACK FOOTER //
// src/App.vue